import type { PagedResultDto } from "@services/dto/pagedResultDto"
import floorStaffService from "@services/floorStaff/floorStaffService"
import { action, makeAutoObservable, observable } from "mobx"

class BussinessTargetStore {
  @observable isLoading!: boolean
  @observable tableData!: PagedResultDto<any>
  @observable detailData!: any

  constructor() {
    makeAutoObservable(this)
    this.tableData = { items: [], totalCount: 0 }
    this.detailData = {}
  }

  @action
  async createOrUpdate(body: any) {
    if (!body.id) {
      const result = await floorStaffService.create(body)
      this.detailData = result
      this.tableData.items.push(result)
    } else {
      const result = await floorStaffService.update(body)
      this.tableData.items = this.tableData.items.map((x) => {
        if (x.id === body.id) x = result
        return x
      })
    }
  }

  @action
  async newCustomer() {
    this.detailData = {
      id: 0,
    }
  }

  @action
  async activateOrDeactivate(id: number, isActive: boolean) {
    await floorStaffService.activateOrDeactivate(id, isActive)
  }
  @action
  async bulkActive(id: number[]) {
    await floorStaffService.bulkActive(id)
  }
  @action
  async get(id: number) {
    const result = await floorStaffService.get(id)
    this.detailData = result
  }

  @action
  async getAll(params: any) {
    this.isLoading = true
    const result = await floorStaffService
      .getAll(params)
      .finally(() => (this.isLoading = false))
    this.tableData = result
  }
}

export default BussinessTargetStore
